import {
  Criteria,
  QuotaPayload,
} from '../../shared/interfaces/quota.interface';
import { ChildrenQuotaMatch } from './quota-filter';

export class RecreatedQuotaKey {
  constructor(private readonly _quota: QuotaPayload) {}

  generate(): string {
    const isChildrenQuota = new ChildrenQuotaMatch().filter(this._quota);
    if (isChildrenQuota) {
      return this._complexKey();
    }

    return this._simpleKey();
  }

  private _simpleKey(): string {
    return this._quota.text!;
  }

  private _complexKey() {
    return this._quota.criteria
      .map(
        (criteria) =>
          `${criteria.condition_codes}-${criteria.original_maximum}-${
            criteria.original_minimum
          }-${this._conditions(criteria)}`
      )
      .join('-');
  }

  private _conditions(criteria: Criteria): string {
    if (criteria.condition_codes && criteria.condition_names) {
      return `${criteria.original_percentage}-${criteria.condition_codes![0]}-${
        criteria.condition_names![0]
      }`;
    }

    return `${criteria.range_sets![0].from}-${criteria.range_sets![0].to}-${
      criteria.range_sets![0].units
    }`;
  }
}

export class RecreatedQuotas {
  private readonly _quotas = new Map<string, QuotaPayload>();

  add(quotas: QuotaPayload[]): void {
    for (let quota of quotas) {
      const key = new RecreatedQuotaKey(quota).generate();
      const recreated = this._quotas.get(key);

      if (!recreated) {
        this._quotas.set(key, quota);
      }
    }
  }

  all(): QuotaPayload[] {
    return Array.from(this._quotas.values());
  }
}
